import { Heading } from 'ui-kit/typography'
import { Link } from 'ui-kit/actions/link/Link'
import Setting from './icon-on-demand-connector.svg'
import classes from './IntegrationPageOnDemandConnector.module.scss'

export function IntegrationPageOnDemandConnector() {
  return (
    <section className={classes.section}>
      <div className={classes.body}>
        <div className={classes.wrapper}>
          <div className={classes.content}>
            <Heading as={'h2'} size={'xl'} className={classes.title}>
              On-demand Connector
            </Heading>

            <ul className={classes.list}>
              <li className={classes.item}>
                We verified that this integration is supported, but did not
                pre-map it yet.
              </li>
              <li className={classes.item}>
                If you are not a customer yet, we can build this connector for
                you during the trial.
              </li>
              <li className={classes.item}>
                If you are an existing customer, reach out to our success team
                for details.
              </li>
            </ul>

            <Link
              className={classes.link}
              asPageButton
              type='primary'
              href='mailto:hello@integration.app?subject=Request a connector'
              target='_self'
            >
              Contact us for details
            </Link>
          </div>

          <div className={classes.visual}>
            <img
              className={classes.image}
              src={Setting.src}
              width={547}
              height={388}
              alt=''
              aria-hidden='true'
              loading='lazy'
            />
          </div>
        </div>
      </div>
    </section>
  )
}
